export enum TimeOfDay {
  morning = 'morning',
  afternoon = 'afternoon',
  evening = 'evening'
}
